import { NetworkService } from '../services'
import { BaseTransport } from '../transports'
import { RequestUserConfig } from '../common/types'
import LivePricingResponseTransport, {
    ComboLivePricingParamsTransport,
    ComboLivePricingResponseTransport,
    LivePricingParamsTransport,
} from '../transports/live-pricing-transport'

class PricingClient {
    public getLivePrices({
        params,
    }: {
        params: LivePricingParamsTransport
    }): Promise<BaseTransport<LivePricingResponseTransport>> {
        return NetworkService.get({
            url: `/api/v1/prices/listings/${params.listingId}/live`,
            params,
        })
    }

    public getComboLivePrices({
        user,
        params,
        signal,
    }: {
        user?: RequestUserConfig
        params: ComboLivePricingParamsTransport
        signal?: AbortSignal | null
    }): Promise<BaseTransport<ComboLivePricingResponseTransport>> {
        const headers = user && {
            'x-language': user.language,
            'x-domain': user.domain,
            ...(user.session?.id && { 'x-session-id': user.session.id }),
        }

        const query = [
            `listingIds=${encodeURIComponent(params.listingIds)}`,
            `arrival=${params.arrival}`,
            `departure=${params.departure}`,
            `adults=${params.adults}`,
            `childrenAges=${encodeURIComponent(params.childrenAges)}`,
            `pets=${params.pets}`,
        ].join('&')

        return NetworkService.get({
            url: `/api/v1/prices/listings/live?${query}`,
            ...(headers && { headers }),
            restConfig: { signal },
        })
    }
}

export default new PricingClient()
